import React, { useEffect, useState } from 'react'

import classes from "./AutomationsGrid.module.css";
import Card from './Card';
import { useSelector } from 'react-redux';

import IFTTTRuleLayout from '../UI/Cards/Automations/EditAutomations/IFTTTRuleLayout';
import CreateAutomation from '../UI/Cards/Automations/EditAutomations/CreateAutomation';
import ScheduleContentLayout from '../UI/Cards/Automations/EditAutomations/ScheduleContentLayout';
import HolidayModeCard from '../UI/Cards/Automations/HolidayMode/HolidayModeCardContentLayout';
import HolidayModeCardContentLayout from '../UI/Cards/Automations/HolidayMode/HolidayModeCardContentLayout';
import { se } from 'date-fns/locale';
import AccessRestrictionLayout from '../UI/Cards/Automations/CreateAccessRestriction/AccessRestrictionLayout';
import AdvRuleLayout from '../UI/Cards/Automations/EditAutomations/AdvRuleContentLayout';
import { single } from 'rxjs';
import SmartRuleCard from '../UI/Cards/Rules/SmartRuleCard';


const AutomationsGrid = (
    { 
        DeviceRules, 
        siteSchedules, 
        siteHolidayModes, 
        outputs, 
        inputs, 
        allListOptionsArray, 
        HandleSelectAutomation, 
        fetchAutomations, 
        numInput, 
        smartLocks, 
        updateRemainRules, 
        siteAccessRestrictions,
        advRules
    }
) => {
    //-------------------------------------------- Filtering Auotmations -------------------------------------------------------------
    const DeviceRulesEntries = Object.entries(DeviceRules || [])
    const filteredArray = DeviceRulesEntries.filter(([key, value]) => {
        if (value && value.outputs && (key != value.outputs)) {
            return true
        }
        return false; // Filter out entries where value or value.outputs is undefined
    });

    //move input pin into the object 5: { ... }  to  { Pin: 5, ...}
    const Rules = filteredArray.map(([Pin, value]) => ({ Pin: parseInt(Pin), ...value }));
    //--------------------------------------------- parsing Device Firmware number to work out inputType -------------------------------
    const singleDeviceHeaderData = useSelector(state => state.service.singleDeviceHeaderData);
    const role = useSelector(state => state.auth.role);
    const firmware = singleDeviceHeaderData.firmware;
    const Firmware = firmware.split('.')
    const firmwareMajor = Firmware[0]
    const firmwareMinor = Firmware[1]
    const supportsAdvRules = (singleDeviceHeaderData.type == "S" || singleDeviceHeaderData.type == 'ESP')
    //---------------------------------------------------------------------------------------------------------------------------------

    // get to get pinName
    const HandlePinName = (item) => {
        const matchedPin = outputs.find(output => output.Pin === item.Pin) || inputs.find(Input => Input.Pin === item.Pin);

        let pinName = [matchedPin]
        return pinName;
    }

    const HandleIsLock = (item) => {
        const rulePin = item.Pin
        return smartLocks.some(lock => lock.outputPin === rulePin);
    }

    const Automations = [
        {
            title: "IFTTT Rule",
            rule: "When Front Door is Open or Closed - Front Door will match that state",
            active: true
        },
        {
            title: "Scheduled Action",
            rule: "Light will auto disarm at 11:30 on Thurs",
            active: true
        },
        {
            title: "Reminder",
            rule: "You will be reminded to arm Front Door at 06:30 on Fri",
            active: false
        },
    ]

    const NumberOfItemsInAutomationsArray = (siteSchedules?.length || 0) + (Rules?.length || 0) + (siteHolidayModes?.length || 0)

    // if the number of items is greater than 4 switch styling from row to wrap grid.    
    const gridStyleConditional = NumberOfItemsInAutomationsArray < 4 ? true : false;

    // filter out rules that already exist
    let remainingRules = allListOptionsArray.filter(listOption =>
        Rules.every(rule => rule.Pin != listOption.Pin)
    );

    // update useState in Automations to allow the pass remainingRules array to CreateAutomations componet 
    useEffect(() => {
        //only update onMount
        updateRemainRules(remainingRules);
    }, [DeviceRules])


    return (
        <div className={classes.deviceGrid}>
            {/* map rules array to cards  */}

            {/* render Create Automation card */}
            <Card>
                <CreateAutomation HandleSelectAutomation={HandleSelectAutomation} numInput={numInput} holdiayMode={siteHolidayModes} supportsAdvRules={supportsAdvRules} />
            </Card>

            {Rules.map((item, index) => {
                // get PinName
                const pinName = HandlePinName(item);

                //check if rule applied to input or output
                let isRuleAppliedToInput = inputs.find(Input => Input.Pin === item.Pin);
                let ruleIsAppliedToLock = smartLocks.some(lock => lock.outputPin == item.Pin);
                if (isRuleAppliedToInput != undefined) {
                    isRuleAppliedToInput = true;
                } else {
                    isRuleAppliedToInput = false;
                }

                // get inputType
                let InputTypeText;
                switch (parseInt(item.inputType)) {
                    case 0:
                        InputTypeText = "Armed";
                        break;
                    case 1:
                        InputTypeText = "Armed or Disarmed";
                        break;
                    case 2:
                        InputTypeText = "Disarmed";
                        break;
                    case 3:
                        if (firmwareMajor >= 2 || (firmwareMajor == 1 && firmwareMinor >= 9)) {
                            InputTypeText = "Pulse";
                        }
                        break;
                    case 4:
                        if (firmwareMajor >= 2 || (firmwareMajor == 1 && firmwareMinor >= 9)) {
                            InputTypeText = "Reverse Pulse";
                        }
                        break;
                }


                // get outPutname from getRule object -- being item
                const arrayofOutputs = item.outputs.split(",");
                const arrayofOutputsInts = arrayofOutputs.map(output => parseInt(output));

                let matchedOutput;

                if (arrayofOutputsInts.length > 0) {
                    matchedOutput = outputs.filter(output => {
                        // Check if any element in arrayofOutputsInts matches the current output.Pin
                        // and ensure output.Pin does not match pinName.Pin
                        return arrayofOutputsInts.some((outputInt) => output.Pin === outputInt) && output.Pin !== pinName[0].Pin
                    });
                }

                let LinkOutPutsArray = matchedOutput && matchedOutput;


                // get inputRule
                let InputRuleText;
                switch (parseInt(item.inputRule)) {

                    case 0:
                        InputRuleText = "match the state";
                        if (ruleIsAppliedToLock) {
                            InputRuleText = " be disarmed"
                        }
                        break;
                    case 1:
                        InputRuleText = "oppose the state";
                        if (ruleIsAppliedToLock) {
                            InputRuleText = " be armed"
                        }
                        break;
                    case 2:
                        InputRuleText = " toggle state";
                        break;
                    default:
                        if (item.inputType == 3) {
                            let seconds = item.inputRule
                            let secondsDivided = seconds / 60000
                            if (secondsDivided < 1) {
                                secondsDivided = seconds / 1000
                                InputRuleText = `temporarily arm for ${item.inputRule / 1000} seconds`
                            } else {
                                InputRuleText = `temporarily arm for ${secondsDivided} minutes`
                            }

                        } else if (item.inputType == 4) {
                            let seconds = item.inputRule
                            let secondsDivided = seconds / 60000
                            if (secondsDivided < 1) {
                                secondsDivided = seconds / 1000
                                InputRuleText = `temporarily disarm for ${item.inputRule / 1000} seconds`
                            } else {
                                InputRuleText = `temporarily disarm for ${secondsDivided} minutes`
                            }
                        }
                }

                return (
                    <IFTTTRuleLayout key={item.Pin} listoptions={remainingRules} OutPutOptions={outputs} title="Legacy Rule" pinName={pinName} item={item} InputTypeText={InputTypeText} InputType={item.inputType} LinkOutPutsArray={LinkOutPutsArray} InputRuleText={InputRuleText} OutPutsPinNames={outputs} InputsPinNames={inputs} isRuleAppliedToInput={isRuleAppliedToInput} fetchAutomations={fetchAutomations} ruleIsAppliedToLock={ruleIsAppliedToLock} />
                )
            })}

            { advRules && advRules.length > 0 && advRules?.map((item, index) => {
                return (
                    <AdvRuleLayout key={item.id} item={item} fetchAutomations={fetchAutomations} pins={allListOptionsArray} smartLocks={smartLocks}/>
                )
            })}

            {/* map schedules to cards */}
            {siteSchedules && siteSchedules?.map((item, index) => {
                return (
                    <ScheduleContentLayout key={item.id} item={item} outputs={outputs} inputs={inputs} fetchAutomations={fetchAutomations} />
                )
            })}

            {/* map holidayModes to cards */}
            {siteHolidayModes && siteHolidayModes?.length >= 1 && siteHolidayModes?.map((holdiayMode, index) => {
                return (
                    <HolidayModeCardContentLayout key={holdiayMode.id} holdiayMode={holdiayMode} OutPutsPinNames={outputs} smartLocks={smartLocks} fetchAutomations={fetchAutomations} />
                )
            })}

            {/*Map site access restrictions to cards*/}
            {siteAccessRestrictions?.map((restriction, index) => {
                return (
                    <AccessRestrictionLayout key={restriction.id} item={restriction} fetchAutomations={fetchAutomations} />
                )
            })}
        </div>
    )
}

export default AutomationsGrid